import React, { Component } from 'react'
import './WorldMap.scss';
// import ChartOrTable from './../../components/chartTable/ChartOrTable';
import ReactEcharts from 'echarts-for-react';
// import axios from 'axios';
import * as echarts from 'echarts';
import worldGeoJson from './config/world.json';
// import hkGeoJson from './config/hk.json';
import { mapData } from './config/mapData';
import { colorUtil } from '../../util/colorUtil';
// 注册地图
echarts.registerMap('world', worldGeoJson);
// echarts.registerMap('hk', hkGeoJson);

export default class WorldMap extends Component {
  componentDidMount() {
  }

  getOption = () => {
    // axios.get("./config/world.json").then(geoJson => {
    //   console.log(res);
    // })
    let option = {
      title: {
        text: 'Population Density of Hong Kong （2011）',
        subtext: 'Data from Wikipedia',
        sublink:
          'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}<br/>{c} (p / km2)'
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          dataView: { readOnly: false },
          restore: {},
          saveAsImage: {}
        }
      },
      visualMap: {
        type: 'piecewise', // 分段型 visualMap
        // pieces: [
        //   { min: 0, max: 1000, color: '#ffefd5' }, // 根据值范围设置颜色
        //   { min: 1000, max: 10000, color: '#ffdab9' },
        //   { min: 10000, max: 100000, color: '#cd853f' },
        //   { min: 100000, max: 1000000, color: '#3a15d1' },
        //   { min: 1000000, max: 10000000, color: '#07754f' },
        //   { min: 10000000, max: 100000000, color: '#f2cf43' },
        //   { min: 100000000, max: 1000000000, color: '#8b4513' },
        //   { min: 1000000000, max: 1500000000, color: '#f5265f' },
        // ],
        pieces: this.genIntervalArray(1500000000, 0, 50),
        min: 0,
        max: 1500000000,
        // text: ['High', 'Low'],
        realtime: false,
        calculable: true,
        inRange: {
          color: ['lightskyblue', 'yellow', 'orangered']
        },
        left: 'right', // visualMap 的位置
        top: 'bottom',
        textStyle: {
          color: '#fff', // 文字颜色
        },
      },
      geo: {
        map: 'world', // 使用注册的地图
        roam: true, // 允许缩放和平移
        label: {
          show: true, // 显示区块名称
          color: '#000', // 标签颜色
        },
        itemStyle: {
          borderColor: '#fff', // 区块边框颜色
        },
      },
      series: [
        // {
        //   name: '香港18区人口密度',
        //   type: 'map',
        //   map: 'hk',
        //   label: {
        //     show: true
        //   },
        //   data: mapData.hkData,
        //   // 自定义名称映射
        //   nameMap:mapData.hkMap 
        // },
        {
          name: '全球',
          type: 'map',
          map: 'world',
          roam: true,
          // projection: {
          //   project: (point) => [point[0] / 180 * Math.PI, -Math.log(Math.tan((Math.PI / 2 + point[1] / 180 * Math.PI) / 2))],
          //   unproject: (point) => [point[0] * 180 / Math.PI, 2 * 180 / Math.PI * Math.atan(Math.exp(point[1])) - 90]
          // },
          // center: [115.97, '30%'],
          label: {
            show: true
          },
          data: mapData.worldData.map(m => {
            return {
              name: m.name,
              value: m.pop,
            };
          }),
          // 自定义名称映射
          nameMap: mapData.worldMap,
          // itemStyle:
        }
      ]
      // geo: [
      //   {
      //     map: 'hk', // 使用第一个注册的地图
      //     roam: true, // 允许缩放和平移
      //     left: '5%', // 左侧位置
      //     top: '10%', // 顶部位置
      //     width: '40%', // 宽度
      //     height: '80%', // 高度
      //     label: {
      //       emphasis: {
      //         show: false, // 高亮时不显示标签
      //       },
      //     },
      //     itemStyle: {
      //       normal: {
      //         areaColor: '#323c48', // 地图区域颜色
      //         borderColor: '#111', // 边框颜色
      //       },
      //       emphasis: {
      //         areaColor: '#2a333d', // 高亮时的区域颜色
      //       },
      //     },
      //   },
      //   {
      //     map: 'world', // 使用第二个注册的地图
      //     roam: true, // 允许缩放和平移
      //     right: '5%', // 右侧位置
      //     top: '10%', // 顶部位置
      //     width: '40%', // 宽度
      //     height: '80%', // 高度
      //     label: {
      //       emphasis: {
      //         show: false, // 高亮时不显示标签
      //       },
      //     },
      //     itemStyle: {
      //       normal: {
      //         areaColor: '#323c48', // 地图区域颜色
      //         borderColor: '#111', // 边框颜色
      //       },
      //       emphasis: {
      //         areaColor: '#2a333d', // 高亮时的区域颜色
      //       },
      //     },
      //   },
      // ],
    };
    return option;
  }

  genIntervalArray = (max, min, interval) => {
    const section = Math.ceil(max / interval);
    let array = [];
    for (let i = 1; i < interval + 2; i++) {
      array.push({ min: min + (i - 1) * section, max: i * section, color: colorUtil.getRandomHex() });
    }
    return array;
  }

  onChartReady = (echarts) => {
    // console.log(echarts);
    // echarts.registerMap('world', geoJson);
  }

  render() {
    return (
      <div className="world-map">
        <ReactEcharts
          style={{ height: "100%", width: "100%" }}
          option={this.getOption()}
          onChartReady={this.onChartReady}
        />
      </div>
    )
  }
}